var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isIndex)?_c('SiteIndex',{attrs:{"white-list":[],"model":_vm.model}}):(_vm.isShopCart)?_c('site-shop-cart',{attrs:{"model":_vm.model}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }